export const ru = {
    clients: 'Клиенты',
    currency: 'Валюта',
    name: 'Название',
    period: 'Период',
    'price-context': 'CPM',
    'shows-max': 'Показы, max',
    'shows-min': 'Показы, min',
    status: 'Статус',
    targetings: 'Таргетинги'
};
